(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wow-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const getFormValue = (formData, name) => {
      const value = formData.get(name);
      return typeof value === 'string' ? value.trim() : '';
    };

    let phoneParserPromise;

    const loadPhoneParser = (url) => {
      if (
        window.libphonenumber &&
        typeof window.libphonenumber.parsePhoneNumberFromString === 'function'
      ) {
        return Promise.resolve(window.libphonenumber);
      }

      if (!url) {
        return Promise.reject(new Error('Phone parser URL is unavailable'));
      }

      if (!phoneParserPromise) {
        phoneParserPromise = new Promise((resolve, reject) => {
          const existingScript = document.querySelector('script[data-wow-phone-parser]');
          const script = existingScript || document.createElement('script');

          const handleLoad = () => {
            if (
              window.libphonenumber &&
              typeof window.libphonenumber.parsePhoneNumberFromString === 'function'
            ) {
              resolve(window.libphonenumber);
              return;
            }

            reject(new Error('Phone parser did not initialize'));
          };

          script.addEventListener('load', handleLoad, { once: true });
          script.addEventListener('error', () => reject(new Error('Phone parser failed to load')), { once: true });

          if (!existingScript) {
            script.src = url;
            script.async = true;
            script.dataset.wowPhoneParser = 'true';
            document.head.append(script);
          }
        });
      }

      return phoneParserPromise;
    };

    const countryDisplayName = (countryCode, displayNames) => {
      if (!displayNames) return countryCode;

      try {
        return displayNames.of(countryCode) || countryCode;
      } catch (error) {
        return countryCode;
      }
    };

    const setupPhoneCountrySelect = async (wrapper) => {
      const select = wrapper.querySelector('[data-phone-country]');
      if (!select) return;

      const defaultCountry = String(
        select.dataset.defaultCountry || wrapper.dataset.contactCountry || 'CA'
      ).toUpperCase();

      try {
        const phoneParser = await loadPhoneParser(wrapper.dataset.phoneParserUrl);
        const language = document.documentElement.lang || 'en';
        const displayNames = typeof Intl.DisplayNames === 'function'
          ? new Intl.DisplayNames([language], { type: 'region' })
          : null;
        const countries = phoneParser.getCountries().slice().sort((a, b) =>
          countryDisplayName(a, displayNames).localeCompare(countryDisplayName(b, displayNames), language)
        );

        select.replaceChildren();
        countries.forEach((countryCode) => {
          const option = document.createElement('option');
          option.value = countryCode;
          option.textContent = `${countryDisplayName(countryCode, displayNames)} (+${phoneParser.getCountryCallingCode(countryCode)})`;
          option.defaultSelected = countryCode === defaultCountry;
          select.append(option);
        });

        if (!countries.includes(defaultCountry)) {
          select.value = countries.includes('CA') ? 'CA' : countries[0];
        }
      } catch (error) {
        select.value = defaultCountry;
      }
    };

    const phonePayloadFrom = async (wrapper, formData) => {
      const raw = getFormValue(formData, 'contact[phone]');
      const selectedCountry = (
        getFormValue(formData, 'contact[phone_country]') || wrapper.dataset.contactCountry || 'CA'
      ).toUpperCase();

      if (!raw) {
        return {
          raw: '',
          e164: '',
          country: selectedCountry,
          extension: '',
          status: 'blank'
        };
      }

      try {
        const phoneParser = await loadPhoneParser(wrapper.dataset.phoneParserUrl);
        const parsed = phoneParser.parsePhoneNumberFromString(raw, selectedCountry);
        const isValid = Boolean(parsed && parsed.isValid());

        return {
          raw,
          e164: isValid ? parsed.number : '',
          country: (isValid && parsed.country) || selectedCountry,
          extension: (parsed && parsed.ext) || '',
          status: isValid ? 'valid' : 'review'
        };
      } catch (error) {
        return {
          raw,
          e164: '',
          country: selectedCountry,
          extension: '',
          status: 'parser_unavailable'
        };
      }
    };

    document.querySelectorAll('[data-wow-form="contact"]').forEach((wrapper) => {
      const form = wrapper.querySelector('form');
      const webhookUrl = wrapper.dataset.contactClickupWebhook;
      if (!form || !webhookUrl || form.dataset.clickupRelayReady === 'true') return;

      form.dataset.clickupRelayReady = 'true';
      let continuingToShopify = false;
      setupPhoneCountrySelect(wrapper);

      form.addEventListener('submit', async (event) => {
        if (continuingToShopify) return;
        if (!form.checkValidity()) return;

        event.preventDefault();

        const formData = new FormData(form);
        const submitButton = form.querySelector('button[type="submit"]');
        const originalButtonText = submitButton ? submitButton.textContent : '';

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Sending...';
        }

        const phonePayload = await phonePayloadFrom(wrapper, formData);
        const payload = {
          form: 'Contact enquiry',
          name: getFormValue(formData, 'contact[name]'),
          email: getFormValue(formData, 'contact[email]'),
          company: getFormValue(formData, 'contact[company]'),
          phone: phonePayload.raw,
          phone_e164: phonePayload.e164,
          phone_country: phonePayload.country,
          phone_extension: phonePayload.extension,
          phone_parse_status: phonePayload.status,
          occasion_or_gifting_need: getFormValue(formData, 'contact[occasion_or_gifting_need]'),
          message: getFormValue(formData, 'contact[body]'),
          country: wrapper.dataset.contactCountry || '',
          source_url: window.location.href,
          submitted_at: new Date().toISOString()
        };

        const frameName = `wow-contact-clickup-${Date.now()}`;
        const iframe = document.createElement('iframe');
        iframe.name = frameName;
        iframe.hidden = true;

        const relayForm = document.createElement('form');
        relayForm.action = webhookUrl;
        relayForm.method = 'post';
        relayForm.target = frameName;
        relayForm.hidden = true;

        Object.entries(payload).forEach(([name, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          relayForm.append(input);
        });

        let relaySubmitted = false;
        let released = false;
        const continueToShopify = () => {
          if (released) return;
          released = true;
          window.clearTimeout(timeout);
          iframe.remove();
          relayForm.remove();
          continuingToShopify = true;
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = originalButtonText;
          }
          form.requestSubmit(submitButton || undefined);
        };

        iframe.addEventListener('load', () => {
          if (relaySubmitted) continueToShopify();
        });

        const timeout = window.setTimeout(continueToShopify, 4000);
        document.body.append(iframe, relayForm);
        relaySubmitted = true;
        HTMLFormElement.prototype.submit.call(relayForm);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wow-header"]) return;
  try {
    
  document.querySelectorAll('.wow-header__menu').forEach((menu) => {
    const toggle = menu.querySelector('.wow-header__menu-toggle');
    if (!toggle) return;

    const updateMenuState = () => {
      const isOpen = menu.hasAttribute('open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggle.setAttribute('aria-label', isOpen ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
    };

    menu.addEventListener('toggle', updateMenuState);
    document.addEventListener('pointerdown', (event) => {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !menu.open) return;
      menu.open = false;
      toggle.focus();
    });
    updateMenuState();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wow-product-main"]) return;
  try {
    
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = Array.from(gallery.querySelectorAll('[data-product-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-product-thumb]'));

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const activeIndex = Number(thumb.dataset.productIndex);

        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          slide.hidden = !isActive;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        thumbs.forEach((button, index) => {
          const isActive = index === activeIndex;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wow-request-mockup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const toTitleCase = (value) =>
      value
        .replace(/-/g, ' ')
        .replace(/\b\w/g, (letter) => letter.toUpperCase());

    const getQueryParams = () => new URLSearchParams(window.location.search);

    const applyRequestContext = (root = document) => {
      if (root.querySelector('[data-wow-board-picker].is-enhanced')) return;
      const params = getQueryParams();
      const product = params.get('product');
      const productTitle = params.get('product_title');
      const collection = params.get('collection');

      const productField = root.querySelector('[data-product-field]');
      if (productField && product) {
        productField.value = product;
      }

      const collectionField = root.querySelector('[data-collection-field]');
      if (collectionField && collection) {
        collectionField.value = collection;
      }

      const productDisplayField = root.querySelector('[data-product-display-field]');
      if (productDisplayField && productTitle) {
        productDisplayField.value = productTitle;
      } else if (productDisplayField && product) {
        productDisplayField.value = toTitleCase(product);
      } else if (productDisplayField && !productDisplayField.value && collection) {
        productDisplayField.value = toTitleCase(collection);
      }
    };

    const setBoostStatus = (wrapper, message, type) => {
      const status = wrapper.querySelector('[data-boost-status]');
      if (!status) return;

      status.textContent = message;
      status.hidden = false;
      status.classList.toggle('is-success', type === 'success');
      status.classList.toggle('is-error', type === 'error');
    };

    const getFormValue = (formData, name) => String(formData.get(name) || '').trim();

    const messageWithOrderDetails = (wrapper, formData) => {
      const message = getFormValue(formData, 'contact[body]');
      const quantity = getFormValue(formData, 'contact[estimated_quantity]');
      const arrival = getFormValue(formData, 'contact[preferred_arrival_date]');
      const budget = getFormValue(formData, 'contact[gift_budget]');
      const details = [];

      if (quantity) details.push(`${wrapper.dataset.orderQuantityLabel}: ${quantity}`);
      if (arrival) {
        details.push(`${wrapper.dataset.orderArrivalLabel}: ${arrival} (${wrapper.dataset.orderArrivalNote})`);
      }
      if (budget) details.push(`${wrapper.dataset.orderBudgetLabel}: ${budget}`);

      if (!details.length) return message;
      return [message, [wrapper.dataset.orderDetailsHeading, ...details].join('\n')]
        .filter(Boolean)
        .join('\n\n');
    };

    let phoneParserPromise;

    const loadPhoneParser = (url) => {
      if (
        window.libphonenumber &&
        typeof window.libphonenumber.parsePhoneNumberFromString === 'function'
      ) {
        return Promise.resolve(window.libphonenumber);
      }

      if (!url) {
        return Promise.reject(new Error('Phone parser URL is unavailable'));
      }

      if (!phoneParserPromise) {
        phoneParserPromise = new Promise((resolve, reject) => {
          const existingScript = document.querySelector('script[data-wow-phone-parser]');
          const script = existingScript || document.createElement('script');

          const handleLoad = () => {
            if (
              window.libphonenumber &&
              typeof window.libphonenumber.parsePhoneNumberFromString === 'function'
            ) {
              resolve(window.libphonenumber);
              return;
            }

            reject(new Error('Phone parser did not initialize'));
          };

          script.addEventListener('load', handleLoad, { once: true });
          script.addEventListener('error', () => reject(new Error('Phone parser failed to load')), { once: true });

          if (!existingScript) {
            script.src = url;
            script.async = true;
            script.dataset.wowPhoneParser = 'true';
            document.head.append(script);
          }
        });
      }

      return phoneParserPromise;
    };

    const countryDisplayName = (countryCode, displayNames) => {
      if (!displayNames) return countryCode;

      try {
        return displayNames.of(countryCode) || countryCode;
      } catch (error) {
        return countryCode;
      }
    };

    const setupPhoneCountrySelect = async (wrapper) => {
      const select = wrapper.querySelector('[data-phone-country]');
      if (!select) return;

      const defaultCountry = String(
        select.dataset.defaultCountry || wrapper.dataset.boostCountry || 'CA'
      ).toUpperCase();

      try {
        const phoneParser = await loadPhoneParser(wrapper.dataset.phoneParserUrl);
        const language = document.documentElement.lang || 'en';
        const displayNames = typeof Intl.DisplayNames === 'function'
          ? new Intl.DisplayNames([language], { type: 'region' })
          : null;
        const countries = phoneParser.getCountries().slice().sort((a, b) =>
          countryDisplayName(a, displayNames).localeCompare(countryDisplayName(b, displayNames), language)
        );

        select.replaceChildren();
        countries.forEach((countryCode) => {
          const option = document.createElement('option');
          option.value = countryCode;
          option.textContent = `${countryDisplayName(countryCode, displayNames)} (+${phoneParser.getCountryCallingCode(countryCode)})`;
          option.defaultSelected = countryCode === defaultCountry;
          select.append(option);
        });

        if (!countries.includes(defaultCountry)) {
          select.value = countries.includes('CA') ? 'CA' : countries[0];
        }
      } catch (error) {
        select.value = defaultCountry;
      }
    };

    const phonePayloadFrom = async (wrapper, formData) => {
      const raw = getFormValue(formData, 'contact[phone]');
      const selectedCountry = (
        getFormValue(formData, 'contact[phone_country]') || wrapper.dataset.boostCountry || 'CA'
      ).toUpperCase();

      if (!raw) {
        return {
          raw: '',
          e164: '',
          country: selectedCountry,
          extension: '',
          status: 'blank'
        };
      }

      try {
        const phoneParser = await loadPhoneParser(wrapper.dataset.phoneParserUrl);
        const parsed = phoneParser.parsePhoneNumberFromString(raw, selectedCountry);
        const isValid = Boolean(parsed && parsed.isValid());

        return {
          raw,
          e164: isValid ? parsed.number : '',
          country: (isValid && parsed.country) || selectedCountry,
          extension: (parsed && parsed.ext) || '',
          status: isValid ? 'valid' : 'review'
        };
      } catch (error) {
        return {
          raw,
          e164: '',
          country: selectedCountry,
          extension: '',
          status: 'parser_unavailable'
        };
      }
    };

    const normalizeCompanyWebsite = (value) => {
      const trimmed = String(value || '').trim();
      if (!trimmed) return '';

      const lowerCaseValue = trimmed.toLowerCase();
      const hasProtocol = lowerCaseValue.startsWith('http://') || lowerCaseValue.startsWith('https://');
      const withProtocol = hasProtocol ? trimmed : `https://${trimmed}`;
      const url = new URL(withProtocol);

      if (!['http:', 'https:'].includes(url.protocol) || url.port) {
        throw new Error('Unsupported website URL');
      }

      url.username = '';
      url.password = '';

      const hostname = url.hostname.replace(/\.$/, '').toLowerCase();
      const isIpAddress = /^(?:\d{1,3}\.){3}\d{1,3}$/.test(hostname) || /^\[.*\]$/.test(hostname);
      const isLocalAddress =
        hostname === 'localhost' ||
        hostname.endsWith('.localhost') ||
        hostname.endsWith('.local') ||
        hostname.endsWith('.internal');
      const isBusinessDomain =
        /^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+(?:[a-z]{2,63}|xn--[a-z0-9-]{2,59})$/i.test(
          hostname
        );

      if (isIpAddress || isLocalAddress || !isBusinessDomain) {
        throw new Error('Website must use a public business domain');
      }

      url.hostname = hostname;
      return url.origin;
    };

    const logoFileFrom = (formData) => {
      const file = formData.get('logo_file');
      return file && typeof file.name === 'string' && file.name ? file : null;
    };

    const updateLogoFilename = (form) => {
      const input = form.querySelector('[data-logo-upload]');
      const button = form.querySelector('[data-logo-button]');
      const buttonText = form.querySelector('[data-logo-button-text]');
      const selected = form.querySelector('[data-logo-selected]');
      const output = form.querySelector('[data-logo-file-name]');
      if (!input) return;

      const file = input.files && input.files[0];

      if (button) {
        button.classList.toggle('has-file', Boolean(file));
      }

      if (buttonText) {
        buttonText.textContent = file
          ? buttonText.dataset.selectedLabel || buttonText.textContent
          : buttonText.dataset.defaultLabel || buttonText.textContent;
      }

      if (output) {
        output.textContent = file ? file.name : '';
      }

      if (selected) {
        selected.hidden = !file;
      }
    };

    const submitToBoost = (wrapper, form) => {
      const webhookUrl = wrapper.dataset.boostWebhook;
      if (!webhookUrl) return;

      const logoInput = form.querySelector('[data-logo-upload]');
      if (logoInput) {
        logoInput.addEventListener('change', () => updateLogoFilename(form));
      }

      const websiteInput = form.querySelector('[data-website-url]');
      const moreDetails = form.querySelector('[data-more-details]');
      if (websiteInput) {
        websiteInput.addEventListener('input', () => websiteInput.setCustomValidity(''));
      }

      form.addEventListener('invalid', (event) => {
        if (moreDetails && moreDetails.contains(event.target)) {
          moreDetails.open = true;
        }
      }, true);

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        if (websiteInput) {
          try {
            websiteInput.value = normalizeCompanyWebsite(websiteInput.value);
            websiteInput.setCustomValidity('');
          } catch (error) {
            websiteInput.setCustomValidity(
              wrapper.dataset.websiteUrlError || 'Enter a public business website using http or https.'
            );
          }
        }

        const boardPicker = form.querySelector('[data-wow-board-picker]');
        if (boardPicker?.wowBoardPicker && !boardPicker.wowBoardPicker.validate()) return;

        if (!form.checkValidity()) {
          if (moreDetails && moreDetails.querySelector(':invalid')) {
            moreDetails.open = true;
          }
          form.reportValidity();
          return;
        }

        const params = getQueryParams();
        let isTestSubmission = params.get('utm_source') === 'readonly_qa';
        try {
          isTestSubmission = isTestSubmission || window.sessionStorage.getItem('wow-analytics-test') === '1';
        } catch (_) {}
        const formData = new FormData(form);
        const submitButton = form.querySelector('button[type="submit"]');
        const originalButtonText = submitButton ? submitButton.textContent : '';
        const collection = getFormValue(formData, 'contact[collection]');
        const productInterest =
          getFormValue(formData, 'contact[product_interest]') || getFormValue(formData, 'contact[product]');
        const country = wrapper.dataset.boostCountry || params.get('country') || '';
        const logoFile = logoFileFrom(formData);
        const phonePayload = await phonePayloadFrom(wrapper, formData);

        if (logoFile && logoFile.size > 20 * 1024 * 1024) {
          setBoostStatus(wrapper, wrapper.dataset.boostFileSizeError || 'Logo files must be 20 MB or smaller.', 'error');
          return;
        }

        const payload = {
          submitted_at: new Date().toISOString(),
          source_url: window.location.href,
          form: getFormValue(formData, 'contact[form]') || 'Mockup request',
          name: getFormValue(formData, 'contact[name]'),
          email: getFormValue(formData, 'contact[email]'),
          company: getFormValue(formData, 'contact[company]'),
          website_url: getFormValue(formData, 'contact[website_url]'),
          phone: phonePayload.raw,
          phone_e164: phonePayload.e164,
          phone_country: phonePayload.country,
          phone_extension: phonePayload.extension,
          phone_parse_status: phonePayload.status,
          product_interest: productInterest,
          collection: collection,
          occasion_or_gifting_need: getFormValue(formData, 'contact[occasion_or_gifting_need]'),
          message: messageWithOrderDetails(wrapper, formData),
          country: country,
          logo_filename: logoFile ? logoFile.name : '',
          logo_upload_included: logoFile ? 'yes' : 'no',
          utm_source: params.get('utm_source') || '',
          utm_medium: params.get('utm_medium') || '',
          utm_campaign: params.get('utm_campaign') || ''
        };

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = wrapper.dataset.boostSubmitting || 'Sending...';
        }

        setBoostStatus(wrapper, wrapper.dataset.boostSubmitting || 'Sending...', 'pending');

        const leadEventId = window.crypto.randomUUID();
        const frameName = `wow-boost-submit-${Date.now()}`;
        const iframe = document.createElement('iframe');
        iframe.name = frameName;
        iframe.hidden = true;

        const originalAttributes = {
          action: form.getAttribute('action'),
          method: form.getAttribute('method'),
          enctype: form.getAttribute('enctype'),
          target: form.getAttribute('target')
        };

        const restoreAttribute = (name, value) => {
          if (value === null) {
            form.removeAttribute(name);
            return;
          }

          form.setAttribute(name, value);
        };

        const payloadInputs = [];

        Object.entries(payload).forEach(([name, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          form.append(input);
          payloadInputs.push(input);
        });

        let submitted = false;
        let completed = false;
        const cleanup = () => {
          window.clearTimeout(timeout);
          window.removeEventListener('message', receiveReceipt);
          restoreAttribute('action', originalAttributes.action);
          restoreAttribute('method', originalAttributes.method);
          restoreAttribute('enctype', originalAttributes.enctype);
          restoreAttribute('target', originalAttributes.target);
          payloadInputs.forEach((input) => input.remove());
          iframe.remove();

          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = originalButtonText;
          }
        };

        const timeout = window.setTimeout(() => {
          if (completed) return;
          completed = true;
          cleanup();
          setBoostStatus(wrapper, 'We could not confirm receipt. Please contact us before submitting again.', 'error');
        }, 15000);

        // Receipt comes from Boost only after the CRM row has been stored.
        // A frame load or a generic HTTP response is not a confirmed enquiry.
        const receiveReceipt = (event) => {
          if (!submitted || completed || event.origin !== new URL(webhookUrl).origin ||
              event.source !== iframe.contentWindow || event.data?.type !== 'wow:mockup-receipt' ||
              event.data?.version !== 1 || event.data?.accepted !== true) return;

          completed = true;
          cleanup();
          setBoostStatus(wrapper, wrapper.dataset.boostSuccess || 'Thanks. Your mockup request has been sent.', 'success');
          form.reset();
          const boardPicker = form.querySelector('[data-wow-board-picker]');
          if (boardPicker?.wowBoardPicker) boardPicker.wowBoardPicker.reset();
          else applyRequestContext(wrapper);
          updateLogoFilename(form);
          if (!isTestSubmission) {
            window.dispatchEvent(new CustomEvent('wow:mockup-confirmed', {
              detail: { eventId: leadEventId }
            }));
          }

          let analyticsConsentGranted = false;
          try {
            const privacy = window.Shopify?.customerPrivacy;
            analyticsConsentGranted = privacy?.analyticsProcessingAllowed?.() === true &&
              privacy.currentVisitorConsent?.()?.analytics === 'yes';
          } catch (_) {}
          if (analyticsConsentGranted) {
            try {
              if (typeof window.Shopify.analytics?.publish === 'function') {
                const result = window.Shopify.analytics.publish('wow_mockup_request_submitted', {
                  receipt_version: 1,
                  receipt_id: leadEventId,
                  is_test: isTestSubmission
                });
                if (result && typeof result.catch === 'function') result.catch(() => {});
              }
            } catch (_) {}
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'wow_mockup_request_submitted',
              form: payload.form,
              product_interest: payload.product_interest,
              collection: payload.collection,
              country: payload.country,
              logo_upload_included: payload.logo_upload_included
            });
          }
        };
        window.addEventListener('message', receiveReceipt);

        document.body.append(iframe);
        form.setAttribute('action', webhookUrl);
        form.setAttribute('method', 'post');
        form.setAttribute('enctype', 'multipart/form-data');
        form.setAttribute('target', frameName);
        submitted = true;
        HTMLFormElement.prototype.submit.call(form);
      });
    };

    applyRequestContext();

    document.querySelectorAll('[data-wow-form="mockup_request"]').forEach((wrapper) => {
      const form = wrapper.querySelector('form');
      if (form) {
        setupPhoneCountrySelect(wrapper);
        submitToBoost(wrapper, form);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
